export const ACTION_LOAD_BALANCE__REQUEST = 'ACTION_LOAD_BALANCE__REQUEST';
export const ACTION_LOAD_BALANCE__SUCCESS = 'ACTION_LOAD_BALANCE__SUCCESS';
export const ACTION_LOAD_BALANCE__FAIL = 'ACTION_LOAD_BALANCE__FAIL';

export const ACTION_LOAD_BALANCE_SUMMARY__REQUEST = 'ACTION_LOAD_BALANCE_SUMMARY__REQUEST';
export const ACTION_LOAD_BALANCE_SUMMARY__SUCCESS = 'ACTION_LOAD_BALANCE_SUMMARY__SUCCESS';
export const ACTION_LOAD_BALANCE_SUMMARY__FAIL = 'ACTION_LOAD_BALANCE_SUMMARY__FAIL';

export const ACTION_LOAD_WEBMASTER_PROFILE__REQUEST = 'ACTION_LOAD_WEBMASTER_PROFILE__REQUEST';
export const ACTION_LOAD_WEBMASTER_PROFILE__SUCCESS = 'ACTION_LOAD_WEBMASTER_PROFILE__SUCCESS';
export const ACTION_LOAD_WEBMASTER_PROFILE__FAIL = 'ACTION_LOAD_WEBMASTER_PROFILE__FAIL';

export const ACTION_EDIT_WEBMASTER_PROFILE__REQUEST = 'ACTION_EDIT_WEBMASTER_PROFILE__REQUEST';
export const ACTION_EDIT_WEBMASTER_PROFILE__SUCCESS = 'ACTION_EDIT_WEBMASTER_PROFILE__SUCCESS';
export const ACTION_EDIT_WEBMASTER_PROFILE__FAIL = 'ACTION_EDIT_WEBMASTER_PROFILE__FAIL';
